export const LogoMark = ({ size = 40 }) => (
  <img
    src="/brand/lb-mark-dark.png"
    alt="Levantisk Bord logo"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className="shrink-0 rounded-full bg-black object-cover ring-1 ring-[#C59B27]/50"
  />
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark size={44} />
    <span className="whitespace-nowrap text-left leading-none">
      <span className={`font-display block text-xl font-semibold tracking-tight ${light ? "text-white" : "text-[#1C1917]"}`}>
        Levantisk <em className={light ? "text-[#E9C46A]" : "text-[#721121]"}>Bord</em>
      </span>
      <span className={`block text-[10px] uppercase tracking-[0.32em] mt-1 ${light ? "text-white/80" : "text-[#721121]"}`}>Restaurang</span>
    </span>
  </span>
);
